import React from 'react';
import ApolloAppProvider from './utils/ApolloProvider';
import DynamicRoutes from './utils/DynamicRoutes';
import { LangProvider } from './utils/LanguageProvider';
import Loader from './components/Loader';
// import eruda from "eruda";
// eruda.init();
function App() {
  return (
    <LangProvider>
      <ApolloAppProvider>
        <Loader />
        <DynamicRoutes />
      </ApolloAppProvider>
    </LangProvider>
  );
}

export default App;
